import React from 'react';
import { motion } from 'framer-motion';

const variants = {
  hidden: { opacity: 0, y: 20 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: i * 0.2 + 0.5,
      duration: 0.5,
      ease: "easeOut",
    },
  }),
};

export default function Hero({ onReplayStory }) {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const yOffset = -80;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  const items = [
    <motion.h1 key="1" custom={1} initial="hidden" animate="visible" variants={variants} className="text-teal-300 font-mono text-md md:text-lg mb-4 tracking-[0.24em] uppercase">
      Platform Engineer · AI Infrastructure
    </motion.h1>,
    <motion.h2 key="2" custom={2} initial="hidden" animate="visible" variants={variants} className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold">
      <span style={{ background:'linear-gradient(120deg,#f8fafc 0%,#e2e8f0 50%,#94a3b8 100%)', WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>
        Ashwin Sridharan.
      </span>
    </motion.h2>,
    <motion.h3 key="3" custom={3} initial="hidden" animate="visible" variants={variants} className="mt-3 max-w-4xl text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-slate-300 leading-[1.05]">
      I build the platforms that make intelligence <span className="text-teal-300">scale.</span>
    </motion.h3>,
    <motion.p key="4" custom={4} initial="hidden" animate="visible" variants={variants} className="mt-6 max-w-xl text-slate-400">
      I design cloud-native platforms, Kubernetes infrastructure, and AI-powered developer systems across AWS, Azure, GCP, and on-prem. My work sits where reliability engineering meets GPU orchestration, LLM inference, and elegant developer experience.
    </motion.p>,
    <motion.div key="5" custom={5} initial="hidden" animate="visible" variants={variants} className="mt-10 flex flex-wrap gap-4 items-center">
       <button
          onClick={scrollToContact}
          className="cursor-pointer text-teal-300 px-8 py-4 rounded-md text-lg font-mono transition-all duration-300 hover:shadow-[0_0_24px_rgba(45,212,191,0.3)]"
          style={{ border:'1px solid rgba(45,212,191,0.5)', background:'rgba(45,212,191,0.06)' }}
        >
          Get In Touch
        </button>
        {onReplayStory && (
          <button
            onClick={onReplayStory}
            className="cursor-pointer text-slate-400 px-6 py-4 rounded-md text-sm font-mono hover:text-teal-300 transition-all duration-300 flex items-center gap-2"
            style={{ border:'1px solid rgba(51,65,85,0.6)', background:'rgba(15,23,42,0.4)' }}
          >
            <span className="text-teal-400">▶</span> Replay My Story
          </button>
        )}
    </motion.div>
  ];

  return (
    <section id="hero" className="min-h-screen flex items-center justify-start relative overflow-hidden pt-16">
      {/* decorative glow ring */}
      <div className="absolute right-[-18rem] top-1/2 -translate-y-1/2 w-[760px] h-[760px] rounded-full pointer-events-none"
        style={{ background: 'radial-gradient(circle,rgba(45,212,191,0.06) 0%,transparent 65%)' }} />
      <div className="absolute right-[-6rem] top-1/2 -translate-y-1/2 w-[520px] h-[520px] rounded-full pointer-events-none"
        style={{ border: '1px solid rgba(45,212,191,0.07)' }} />
      <div className="absolute right-24 top-1/2 -translate-y-1/2 w-[300px] h-[300px] rounded-full pointer-events-none"
        style={{ border: '1px solid rgba(45,212,191,0.05)' }} />
      <div className="relative z-10">
        {items}
      </div>
    </section>
  );
}